import Keycloak from 'keycloak-js'
import { type App } from 'vue'
import _ from 'lodash'

const keycloak: Keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: 'mobidic',
  clientId: 'mobidic-fe'
})

export class UserFunctions {
  isAdmin() {
    return _.indexOf(keycloak.tokenParsed?.realm_access?.roles, 'ROLE_ADMIN') !== -1
  }
}

const KeycloakPlugin = {
  install: (app: App): void => {
    app.config.globalProperties.$keycloak = keycloak
    app.provide('keycloak', keycloak)
    app.provide('userFunctions', new UserFunctions())
  }
}

export default KeycloakPlugin
export { keycloak }
